import useSWR from "swr"

const useGlobal = (key) => {
  const { data, mutate } = useSWR(`global:${key}`, null, {
    initialData: null,
  })

  const setData = (value) => {
    mutate(value, false)
  }

  return [data, setData]
}

export default useGlobal
